import { render } from "./SDKPreview.vue?vue&type=template&id=4ae6a986&scoped=true"
import script from "./SDKPreview.vue?vue&type=script&lang=js"
export * from "./SDKPreview.vue?vue&type=script&lang=js"

import "./SDKPreview.vue?vue&type=style&index=0&id=4ae6a986&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_typescript@5.9.3__webpack@5.107.2_4de69cea878ee2f242d39cab111b5a83/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae6a986"]])

export default __exports__